<app-message *ngIf="previewSuccess" title="Success!" [text]="previewText" dismissible="true"
    (dismiss)="dismissPreview()" severity="success"></app-message>
<app-message *ngIf="previewFailure" [text]="previewText" dismissible="true" (dismiss)="dismissPreview()"
    severity="error"></app-message>

<div [@inOutAnimation] class="mx-auto py-6 px-4 sm:px-6 lg:px-8">
    <table class="min-w-full divide-y divide-gray-200">
        <thead class="border-bottom">
            <tr class="border-top">
                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Account Number
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Short Name
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Rep Code
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Delivery
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    O/C
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Email
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Preview Email
                </th>
            </tr>
        </thead>
        <tbody *ngIf="searchNotFound" class="bg-white divide-y divide-gray-200">
            <tr>
                <td class="pb-6" colspan="9">
                    <app-message title="No data matches for the given search criteria." text="No records to display."></app-message>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="pageSearchLoading" class="bg-white divide-y divide-gray-200">
            <tr>
                <td colspan="9">
                    <div class="flex justify-center p-4 text-sm text-gray-500 animate-pulse">
                        <span>Loading...</span>
                    </div>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="searchError" class="bg-white divide-y divide-gray-200">
            <tr>
                <td class="pb-6" colspan="9">
                    <app-message severity="error" dismissible="true" (dismiss)="dismissAccountSearchError()"
                        text="An error occured searching. Please try again later."></app-message>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="!searchNotFound && !pageSearchLoading" class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let taxDocDetail of rows" class="border-top">
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocDetail.accountNumber}}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocDetail.shortName}}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocDetail.repCode}}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocDetail.deliveryIndicator}}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocDetail.correctionIndicator}}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                    <div *ngFor="let email of taxDocDetail.emails">{{email}}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                    <div *ngIf="taxDocDetail.emails.length > 0">
                        <button *ngIf="!previewLoading"
                            class="bg-blue-700 hover:bg-blue-900 text-white py-2 px-4 ml-1 rounded-full text-sm"
                            (click)="sendTestEmail(taxDocDetail)">Preview
                        </button>
                        <button *ngIf="previewLoading && taxDocDetail.accountNumber != previewAccountNumber"
                            class="bg-blue-700 text-white py-2 px-4 ml-1 rounded-full cursor-not-allowed text-sm">
                            Preview
                        </button>
                        <button *ngIf="previewLoading && taxDocDetail.accountNumber == previewAccountNumber"
                            class="bg-gray-300 text-black py-2 px-2.5 ml-1 rounded-full cursor-not-allowed text-sm">
                            <span class="animate-pulse">Loading...</span>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>